

export default function BillLine({text1,text2,styles,type,myClass}) {
  return (
    <div className={`d-flex  ${myClass} flex-wrap`} >
        <div className={`${type=='total' ? styles.totalBill : styles.width60 }  ${styles.BillLine}`}>
          <span> {text1} </span>    
        </div>
        <div className={`${type=='total' ? styles.totalBill : ''} ${styles.BillLine}`}>
          {text2}    
        </div>
    </div>
  )
}
